/* Product card interactivity — INXL World.
 * Inline variant selection + add-to-cart from the card, via the Shopify AJAX
 * Cart API (/cart/add.js). Ported from ProductCard.tsx behaviour.
 *
 * Each card embeds JSON: { options:[names], optionValues:[[..],[..]], variants:[{id,opts,available}] }.
 * Chips carry data-opt-index (option position) + data-opt-value. Single-value
 * options are auto-selected. The add button is disabled until every option is
 * chosen, then POSTs the resolved variant id.
 */
(function () {
  function initCard(card) {
    if (card.dataset.cardInit === '1') return;
    var dataEl = card.querySelector('.product-card__data');
    var addBtn = card.querySelector('[data-add]');
    var priceEl = card.querySelector('[data-card-price]');
    if (!dataEl || !addBtn) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    card.dataset.cardInit = '1';

    var options = data.options || [];
    var optionValues = data.optionValues || [];
    var variants = data.variants || [];
    var isSimple = options.length <= 1 && (options.length === 0 || options[0] === 'Title');

    var selected = {};
    // Auto-select any option that has exactly one value (fixed axis).
    optionValues.forEach(function (vals, i) {
      if (vals && vals.length === 1) selected[i] = vals[0];
    });

    function missingOptionIndex() {
      for (var i = 0; i < options.length; i++) {
        if (options[i] === 'Title') continue;
        if (selected[i] == null) return i;
      }
      return -1;
    }

    function resolveVariant() {
      if (isSimple) return variants[0] || null;
      if (missingOptionIndex() !== -1) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < v.opts.length; j++) {
          if (selected[j] != null && v.opts[j] !== selected[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    // A given option value is available when some variant carrying it — and
    // matching the currently-selected OTHER axes — is in stock. Drives the
    // strike-through on sold-out sizes, mirroring the PDP.
    function valueAvailable(idx, val) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.opts[idx] !== val) continue;
        var ok = true;
        for (var j = 0; j < options.length; j++) {
          if (j === idx || options[j] === 'Title') continue;
          if (selected[j] != null && v.opts[j] !== selected[j]) { ok = false; break; }
        }
        if (ok && v.available) return true;
      }
      return false;
    }
    function syncAvailability() {
      if (isSimple) return;
      card.querySelectorAll('[data-opt-value]').forEach(function (chip) {
        var idx = parseInt(chip.getAttribute('data-opt-index'), 10);
        var avail = valueAvailable(idx, chip.getAttribute('data-opt-value'));
        chip.classList.toggle('is-unavailable', !avail);
        chip.setAttribute('aria-disabled', avail ? 'false' : 'true');
      });
    }

    function render() {
      syncAvailability();
      if (addBtn.disabled && addBtn.dataset.soldout === '1') return; // hard sold-out from Liquid
      if (card.dataset.added === '1') {
        addBtn.disabled = false;
        addBtn.textContent = 'In cart ✓';
        return;
      }
      var miss = isSimple ? -1 : missingOptionIndex();
      if (miss !== -1) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select ' + String(options[miss]).toLowerCase();
        return;
      }
      var v = resolveVariant();
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      if (priceEl && v.price) priceEl.textContent = v.price;
      if (!v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; return; }
      addBtn.disabled = false;
      addBtn.textContent = addBtn.dataset.label || 'Add to cart';
    }

    card.querySelectorAll('[data-opt-value]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        // Sold-out values (struck through) are still selectable — mirrors pdp.js.
        var idx = parseInt(chip.getAttribute('data-opt-index'), 10);
        selected[idx] = chip.getAttribute('data-opt-value');
        var group = chip.parentNode;
        group.querySelectorAll('[data-opt-index="' + idx + '"]').forEach(function (c) {
          c.classList.toggle('is-selected', c === chip);
        });
        card.dataset.added = '0';
        render();
      });
    });

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var v = resolveVariant();
      if (!v || !v.available) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      // Pre-order line-item property → carries the dispatch date into the cart,
      // order, and Order-confirmation email (mirrors assets/pdp.js).
      var props = null;
      if (addBtn.dataset.preorder === '1') {
        var ship = addBtn.dataset.preorderShip;
        props = { 'Pre-order': ship ? ('Ships from ' + ship) : 'Yes' };
        // Hidden, sortable ISO copy so the email can pick the latest date across items.
        var iso = addBtn.dataset.preorderShipIso;
        if (iso) props['_preorder_iso'] = iso;
      }
      var p;
      if (window.__cart && window.__cart.addToCart) {
        // Shared cart handles add + opens the drawer + updates the header count.
        p = window.__cart.addToCart(v.id, 1, props);
      } else {
        p = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1, properties: props || undefined })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (res) { refreshCartCount(); return res; });
      }
      p.then(function () { card.dataset.added = '1'; render(); })
        .catch(function () { card.dataset.added = '0'; render(); });
    });

    // Mark a Liquid-side sold-out button so render() leaves it alone.
    if (addBtn.disabled && !isSimple && missingOptionIndex() === -1) {
      var rv = resolveVariant();
      if (rv && !rv.available) addBtn.dataset.soldout = '1';
    }

    render();
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count < 1;
        });
      })
      .catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('[data-product-card]').forEach(initCard);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  // Let dynamically-injected cards (e.g. the wishlist page) initialise on demand.
  window.__productCards = { init: initAll };
})();
